export interface IAssistenza {
  id?: string,
  codice?: string,
  tipo: TipoAssistenza,
  idTratta?: string,
  idStazioneEntrata?: string,
  idStazioneUscita?: string,
  idPista?: string,
  data?: Date,
  classeVeicolo?: ClasseVeicolo
  tipoVeicolo?: string,
  targa?: string,
  importoRimborsato?: number,
  note?: string,
  noteBackoffice?: string,
  tipoCodice?: TipoCodice,
  barcode?: string,
  tipoAssistenzaCassa?: ModalitaAssistenzaCasse,
  pedaggio?: number,
  dichiarati?: number,
  rilevatiAllaCassa?: number,
  restoErogato?: number,
  restoConsegnato?: number,
  nome?: string,
  cognome?: string,
  email?: string,
  telefono?: string,
  tipoPagamento?: TipoPagamento,
  tipoScontrino?: TipoScontrino,
  stato?: StatoAssistenza,
  importoRitrovato?: number,
  incassoRMPP?: number,
  nomeCompletoOperatore?: string,
  nomeCompletoApprovatore?: string
}

export enum TipoAssistenza {
  RimborsoScontriniDiCredito = "RimborsoScontriniDiCredito",
  AssistenzaCasse = "AssistenzaCasse",
  DenaroRitrovato = "DenaroRitrovato",
  ScontrinoManuale = "ScontrinoManuale",
  Segnalazione = "Segnalazione"
}

// Tipo del codice (barcode) dell'assistenza: la violazione segue la stessa gestione degli RMPP
export enum TipoCodice {
  Nessuno = "Nessuno",
  Rmpp = "Rmpp",
  Violazione = "Violazione"
}

export enum TipoPagamento {
  Contanti = "Contanti",
  Carta = "Carta"
}

export enum TipoScontrino {
  Pedaggio = "Pedaggio",
  IncassoRMPP = "IncassoRMPP"
}

export enum ClasseVeicolo {
  DueAssiClasseA = "DueAssiClasseA",
  DueAssiClasseB = "DueAssiClasseB",
  TreAssi = "TreAssi",
  QuattroAssi = "QuattroAssi",
  CinqueoPiuAssi = "CinqueoPiuAssi"
}

export enum ModalitaAssistenzaCasse {
  DenaroNonConteggiato = "DenaroNonConteggiato",
  RestoNonErogato = "RestoNonErogato",
  Altro = "Altro"
}

export enum StatoAssistenza {
  Aperto = "Aperto",
  DaConfermare = "DaConfermare",
  Confermato = "Confermato",
  Rifiutato = "Rifiutato",
  ChiusoCasse = "ChiusoCasse",
  ChiusoPagamenti = "ChiusoPagamenti"
}

export interface ITotaleTipoAssistenza {
  tipo: TipoAssistenza,
  numeroAssistenze: number,
  importo: number
}